import { initializeErrorReporting } from '@eb/error-reporting';
import { getLocaleOverride, getParentLocale, setupAsync } from '@eb/i18n';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';
import { loadableReady } from '@loadable/component';
import React from 'react';
import { hydrate } from 'react-dom';
import { App } from './app';

// retrieve data from server to hydrate on the client
const props = window.__SERVER_DATA__ || ({} as any);
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

const main = async () => {
    initializeErrorReporting();
    try {
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations: /* webpackChunkName: "wagtail-module-pages-i18n-translation" */ import(
                    `./i18n/translations/${parentLocale}.json`
                ),
            });
        }
    } finally {
        loadableReady(() => {
            hydrate(<App {...props} />, document.getElementById('root'));
        });
    }
};
main();

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
